import React, { createContext, useState, useEffect, useContext } from 'react';
import { SocketContext } from './socketContext';
import axios from '../context/axiosConfig'

// Create the context
const BlockedRowsContext = createContext();

// Create a provider component
const BlockedRowsProvider = ({ children }) => {    
    const [blockedRows, setBlockedRows] = useState([]);
    const [blockedRowsIds, setBlockedRowsIds] = useState([]);
    const socket = useContext(SocketContext);

    // Listen for the `wplyw:blocked` event and update the blocked rows
    useEffect(() => {
        if (!socket) return; // Wait for the socket to be initialized
        socket.on('wplyw:block', ({ wplywid }) => {
            setBlockedRowsIds((prev) => [...new Set([...prev, wplywid])]);
        });

        // Cleanup to avoid memory leaks
        return () => {
            socket.off('wplyw:block');
        };
    }, [socket]);


    useEffect(() => {
        const fetchData = async () => {
            const response = await axios.post("/wplyw/get/blocked", {});
            setBlockedRows(response.data.data);
        }
        fetchData()
    }, [blockedRowsIds]);

    return (
        <BlockedRowsContext.Provider value={{ blockedRows, setBlockedRows }}>
            {children}
        </BlockedRowsContext.Provider>
    );
};

// Custom hook to use the BlockedRows context
const useBlockedRows = () => {
    const context = useContext(BlockedRowsContext);
    if (!context) {
        throw new Error('useBlockedRows must be used within a BlockedRowsProvider');
    }
    return context;
};

export { BlockedRowsContext, BlockedRowsProvider, useBlockedRows };
